/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/CreateDocumentOptions.yaml
import { DocumentStraighteningParameters } from '../core/document_scanner/DocumentEnhancerTypes';
import { ParametricFilter } from '../core/image_processing/ParametricFilters';
/**
Options for creating a document from images.
*/
export class CreateDocumentOptions {
    /** @param source {@displayType `DeepPartial<CreateDocumentOptions>`} */
    constructor(source = {}) {
        /**
          The maximum size of the document image. 0 means no limit.
          
          Default is 0
          */
        this.documentImageSizeLimit = 0;
        /**
          The list of filters applied to the page. If not specified, no filters are applied.
          */
        this.filters = null;
        /**
          Recognizes documents on created document.
          
          Default is true
          */
        this.documentDetection = true;
        /**
          The parameters to use for straightening.
          */
        this.straighteningParameters = new DocumentStraighteningParameters({});
        if (source.documentImageSizeLimit !== undefined) {
            this.documentImageSizeLimit = source.documentImageSizeLimit;
        }
        if (source.filters !== undefined) {
            this.filters =
                source.filters != null
                    ? source.filters.map((it) => {
                        return ParametricFilter.from(it);
                    })
                    : null;
        }
        if (source.documentDetection !== undefined) {
            this.documentDetection = source.documentDetection;
        }
        if (source.straighteningParameters !== undefined) {
            this.straighteningParameters = new DocumentStraighteningParameters(source.straighteningParameters);
        }
    }
}
//# sourceMappingURL=CreateDocumentOptions.js.map